import { render, staticRenderFns } from "./Keynotes.vue?vue&type=template&id=5fffd4e8"
import script from "./Keynotes.vue?vue&type=script&lang=js"
export * from "./Keynotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports